// dependencies
import React from "react";

import { faArrowTrendDown, faArrowTrendUp } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Text from "../../../../../../../components/Text";
import Tooltip from "../../../../../../../components/Tooltip";

// schema
import { Direction } from "../../KPIs/schema/";
// css
import css from "./PercentChangeIndicator.module.scss";

export interface PercentChangeIndicatorProps {
	percentChange: number;
	direction: Direction;
	tooltipText?: string;
}

const PercentChangeIndicator = (props: PercentChangeIndicatorProps) => {
	const { direction, tooltipText, percentChange } = props;
	const pci = (
		<div data-testid="percent-change-indicator" className={`${css.indicator} ${css[direction]}`}>
			<span className={css.row}>
				{direction === "positive" && (
					<>
						<FontAwesomeIcon size="sm" icon={faArrowTrendUp} />
						<Text size="paragraph-3" weight="regular">
							+ {percentChange.toFixed(1)}%
						</Text>
					</>
				)}
				{direction === "negative" && (
					<>
						<FontAwesomeIcon size="sm" icon={faArrowTrendDown} />
						<Text size="paragraph-3" weight="regular">
							- {percentChange.toFixed(1)}%
						</Text>
					</>
				)}
				{direction === "zero" && (
					<Text size="paragraph-3" weight="regular">
						0.0%
					</Text>
				)}
			</span>
		</div>
	);

	return <>{tooltipText ? <Tooltip message={tooltipText}>{pci}</Tooltip> : pci}</>;
};

export default PercentChangeIndicator;
